import React, { useRef, useState, useEffect } from 'react';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import countriesList from 'iso-3166-1-alpha-2';
import * as R from 'ramda';
import { createServiceData, updateServiceData, deleteServiceData, generateLettersForUserIdAndUserServiceId } from '../../../../../../../actions/facilita-api';
import ServiceData from '../../../../../../../constants/models/serviceData';
import { ConnectionTypes, convertConnectionTypesToServiceType, FrenchTypes } from '../../../../../../../constants/utils/connectionTypes';
import AddressInfo from '../../../../../../../constants/models/addressInfo';
import { PostalCityInput } from "../../../../../../../_common/postalCityInput";


export const OtherActivityDetails = ({index, activity, userId, removeActivity, disableModifications, generateLetters}) => {
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    const dispatch = useDispatch();
    const formRef = useRef(null);

    let initState = {
        type: FrenchTypes.otherActivity,
        name: "",
        address: new AddressInfo({addressCountry:'FR', streetAddress: "",streetAddress2: "",postalCode: "", addressLocality: ""}),
        function: "",
    };
    let initCollapsedState = true;
    let activityName = undefined;
    if(!R.isNil(activity.id)){
        initState = activity.payload;
        initCollapsedState = false;
        activityName = activity.payload.name;
    }
    const [collapsed, setCollapsed] = useState(initCollapsedState);
    const [payload, setPayload] = useState({...initState});

    useEffect(() => {
        setPayload({...activity.payload, address: !R.isNil(activity.payload) ? {...activity.payload.address} : new AddressInfo({addressCountry:'FR', streetAddress: "",streetAddress2: "",postalCode: "", addressLocality: ""})});
        activityName = R.isNil(activity.payload) ? '' : activity.payload.name;
        if(!R.isNil(activity.id)){
            setCollapsed(false);
        }
    }, [activity])

    $('[data-toggle="tooltip"]').tooltip();
    return (
			<section className={"card card-body" + (index === 0 ? "" : " mt-4")} id={"activity" + index}>
				<div className="card-header p-0" id="headingUserDetail" role="button" onClick={() => setTimeout(() => setCollapsed(!collapsed), 200)}>
					<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#accordionActivities" + index} aria-expanded={collapsed} aria-controls="accordionActivities">
						<h4 className="h3 font-weight-black container-tight my-auto">{index === 0 ? "Autre activité" : "Autre activité"}</h4>
						{!R.isNil(activityName) ? (
							<span className="mr-auto align-middle">
								<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
								<span className="o-60 align-middle">{activityName}</span>
							</span>
						) : (
							""
						)}
						<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
							<i className={"eva " + (!collapsed ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
						</button>
					</div>
					<p className={"mt-0 fs-3 o-40 collapse" + (collapsed ? " show" : "")}>Association, tutelle, curatelle...</p>
				</div>
				<div className={"mt-4 collapse" + (collapsed ? " show" : "")} id={"accordionActivities" + index} aria-labelledby="headingUserDetail" data-parent={"#activity" + index}>
					<form className="block" noValidate ref={formRef}>
						{/* <h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm mt-4">nom de l’activité</h5> */}
						<div className="row gx-2 mt-n2">
							<div className="col-12 col-md-5">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"name" + index}>
										Organisme
									</label>
									<input required type="text" className="form-control" id={"name" + index} placeholder="ex: Association, tribunal judiciaire..." value={payload.name} disabled={disableModifications && !R.isNil(activity.id)} onChange={(e) => setPayload({ ...payload, name: e.target.value })} />
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-7">
								<div className="form-group">
									<label className="label h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise" + index}>
										Adresse ligne 1
									</label>
									<input
										required
										type="text"
										className="form-control"
										id={"Adresseentreprise" + index}
										placeholder="Adresse de l'organisme"
										disabled={disableModifications && !R.isNil(activity.id)}
										value={payload.address.streetAddress}
										onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress: e.target.value } })}
									/>
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
								<div className="form-group">
									<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + index}>
										Adresse ligne 2
									</label>
									<input
										type="text"
										className="form-control rounded"
										id={"Adresseligne2" + index}
										placeholder="(optionnel)"
										disabled={disableModifications && !R.isNil(activity.id)}
										value={payload.address.streetAddress2}
										onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress2: e.target.value } })}
									/>
								</div>
								<div className="form-row">
									<PostalCityInput
										postalCode={payload.address.postalCode}
										city={payload.address.addressLocality}
										onChange={(updatedAddress) => setPayload({ ...payload, address: { ...payload.address, postalCode: updatedAddress.postalCode, addressLocality: updatedAddress.city } })}
										hasWrapper={false}
										country={payload.address.addressCountry}
										customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
										postalCodeDisabled={disableModifications && !R.isNil(activity.id)}
										cityDisabled={disableModifications && !R.isNil(activity.id)}
									/>
									{/* <div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise" + index} required>
											Code Postal
										</label>
										<input
											required
											type="text"
											className="form-control"
											id={"Postalentreprise" + index}
											placeholder="ex: 75001"
											disabled={disableModifications && !R.isNil(activity.id)}
											value={payload.address.postalCode}
											onChange={(e) => setPayload({ ...payload, address: { ...payload.address, postalCode: e.target.value } })}
										/>
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div>
									<div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise" + index} required>
											Ville
										</label>
										<input
											required
											type="text"
											className="form-control"
											id={"Villeentreprise" + index}
											placeholder="ex: Paris"
											disabled={disableModifications && !R.isNil(activity.id)}
											value={payload.address.addressLocality}
											onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressLocality: e.target.value } })}
										/>
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div> */}
									<div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise" + index}>
											Pays
										</label>
										<select className="custom-select" id={"Paysentreprise" + index} value={payload.address.addressCountry} disabled={disableModifications && !R.isNil(activity.id)} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressCountry: e.target.value } })}>
											{Object.keys(countriesList.getData()).map((country, idx) => {
												return (
													<option key={idx} value={country}>
														{countries.getName(country, "fr", { select: "official" })}
													</option>
												);
											})}
										</select>
									</div>
								</div>
							</div>
						</div>
						<hr className="mb-gutter" />
						{/* <h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm">function professionnel</h5> */}
						<div className="row gx-2 mt-n2">
							<div className="col-12 col-md">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"poste" + index}>
										Intitulé
									</label>
									<input required type="text" className="form-control" id={"poste" + index} disabled={disableModifications && !R.isNil(activity.id)} placeholder="ex: trésorier d'association, tuteur de Madame X..." value={payload.function} onChange={(e) => setPayload({ ...payload, function: e.target.value })} />
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
						</div>
						<hr className="my-0" />
						<div className="card-footer text-right px-0">
							<button
								className="btn btn-sm btn-alert-info border-none loading-btn"
								disabled={disableModifications && !R.isNil(activity.id)}
								onClick={(e) => {
									e.preventDefault();
									if (formRef.current.checkValidity()) {
										let serviceData = new ServiceData({ userId: userId, serviceType: convertConnectionTypesToServiceType(ConnectionTypes.otherActivity), serviceId: FrenchTypes.otherActivity + index, payload: payload });
										if (R.isNil(activity.id)) {
											dispatch(createServiceData(serviceData)).then((s) => {
												if (generateLetters) {
													dispatch(generateLettersForUserIdAndUserServiceId(userId, s.id));
												}
											});
										} else {
											serviceData.id = activity.id;
											dispatch(updateServiceData(serviceData));
										}
										setCollapsed(!collapsed);
									}
									formRef.current.classList.add("was-validated");
								}}>
								enregistrer
								<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
							{index === 0 || (disableModifications && !R.isNil(activity.id)) ? (
								""
							) : (
								<span
									className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
									id="basic-addon2"
									onClick={(e) => {
										e.preventDefault();
										if (R.isNil(activity.id)) {
											removeActivity(activity);
										} else {
											dispatch(deleteServiceData(activity.id, ConnectionTypes.otherActivity));
										}
									}}>
									<i className="eva eva-trash-outline"></i>
								</span>
							)}
						</div>
					</form>
				</div>
			</section>
		);
}